module.exports = __webpack_public_path__ + "img/modalcovermovil.f906d401.png";